// extracted by mini-css-extract-plugin
export var divider = "_2e-0";
export var dividerText = "_2e-1";